import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import tassAxios from '@/apis/tass-api/axios';

type UpdateOrganizationSettingsRequest = {
  organizationId: string;
  shareAnonymizedData: boolean;
};

const updateOrganizationSettings = async ({
  organizationId,
  shareAnonymizedData,
}: UpdateOrganizationSettingsRequest) => {
  const { data } = await tassAxios.patch(
    '/api/Organization/UpdateOrganizationSettings',
    { shareAnonymizedData },
    { params: { organizationId } }
  );
  return data;
};

export const useUpdateOrganizationSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateOrganizationSettings,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['organization', variables.organizationId] });
      toast.success('Organization settings updated successfully!');
    },
    onError: () => toast.error('An error occurred while updating organization settings!'),
  });
};
